export const inputStyle = {
  width: "100%",
  borderRadius: "0.6rem",
  border: "1px solid #6b21f333",
  background: "#FFFFFF",
  padding: "0.55rem 0.8rem",
  fontSize: "0.9rem",
  color: "#241f33",
  outline: "none",
};
